import { isNode } from '../helpers';
import { toUrlFormat } from '../index';
import { getMarkdown } from '../../../client/components/PageElements/ReactMarkdownDisplay/utils';

export const NEW_GUIDE_NAME = 'Introduction';

export const getIndexPageNotesString = (indexPageNotes) => {
  if (!indexPageNotes) {
    return '';
  }
  const indexPageNotesString = indexPageNotes
    .map((note) =>
      note
        .split('\n')
        .map((noteLine) => noteLine.trim())
        .join('\n> '),
    )
    .join('\r\n');
  const noteStart = '\n\n  > **Note:**  \r\n> ';
  return `${noteStart}${indexPageNotesString}`;
};

const getMdContentFromTemplate = (
  name,
  indexPageDescription,
  indexPageNotes,
) => {
  const description = indexPageDescription
    ? `\n  ${getMarkdown(indexPageDescription)}`
    : '';
  const notes = getIndexPageNotesString(indexPageNotes);
  return `# ${name}${description}${notes}`;
};

const addNewGuide = (node, newGuide) => {
  node.data.relatedGuides = node.data.relatedGuides
    ? [newGuide, ...node.data.relatedGuides]
    : [newGuide];
  node.data.docs.description = [];
  node.data.extra.notes = [];
};

const shouldCreateNewGuide = (node) => {
  const hasDescription = node?.data?.docs?.description?.length > 0;
  const hasNotes = node?.data?.extra?.notes?.length > 0;
  const hasIntroduction = node?.data?.relatedGuides?.some(
    (g) => g.name === 'Introduction',
  );
  return !hasIntroduction && (hasDescription || hasNotes);
};

export const createGuideFromIndexPageDescriptionVisitor = (node) => {
  /*
    if the node has description or notes:
    1. we create new introduction guide from the description and the note.
    2. add the new guide to relatedGuides.
    3. clean the description and the notes from the node.
  */
  if (isNode(node) && shouldCreateNewGuide(node)) {
    const newGuideName = NEW_GUIDE_NAME;
    const newGuide = {
      name: newGuideName,
      sortOrder: 0,
      id: `${NEW_GUIDE_NAME.toLowerCase()}-guide::${node.data.name}`,
      content: getMdContentFromTemplate(
        newGuideName,
        node.data.docs.description,
        node.data.extra.notes,
      ),
      urlFormat: toUrlFormat(newGuideName),
    };
    addNewGuide(node, newGuide);
  }
};
